import { useContext, useEffect, useRef, useState } from 'react';
import OffersCarousel from './ui/OffersCarousel';
import SimpleAccordion from './ui/SimpleAccordion';
import { useNavigate, useParams } from 'react-router-dom';
import ProductImageCarousel from './ui/ProductImagesCarousel';
import '../css/ProductPage.css'
import LogContext from '../context/LogContext';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;

const ProductPage = () => {
    const navigate = useNavigate();
    const myContext = useContext(LogContext);
    const { productSlug } = useParams();
    const galleryRef = useRef(null);
    const detailsRef = useRef(null);
    const sentinelUpRef = useRef(null);
    const sentinelDownRef = useRef(null);
    const rowRef = useRef(null)

    const [quantity, setQuantity] = useState(1);
    const [product, setProduct] = useState();
    const [selectedImg, setSelectedImg] = useState(product?.images[0].preview);
    const [galleryWidth, setGalleryWidth] = useState(0)
    const [delta, setDelta] = useState(() =>
        0.9551 * (window.innerWidth - 1380) + 200
    );

    const accordionData = [
        { title: 'What is your return policy?', content: 'You can return within 24 hours.' },
        { title: 'Do you ship internationally?', content: 'Yes, we ship worldwide.' },
        { title: 'How can I contact support?', content: 'Email us at kidorise9@gmail.com.' }
    ];

    function getY(x) {
        return -0.0000003635 * x ** 3 + 0.00194 * x ** 2 - 3.063 * x + 1800.3;
    }


    const handleQuantityChange = (amount) => {
        setQuantity((prev) => Math.max(1, prev + amount));
    };

    const getProductData = async () => {
        try {
            const response = await fetch(`${backendUrl}/getProduct/${productSlug}`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json"
                }
            });
            const data = await response.json();
            setProduct(data[0])
        } catch (error) {
            console.log("error", error)
        }
    };
    const addToCartHandler = async (itemID) => {
        try {
             if (!myContext.user.email) {
            navigate('/login');
        }
        else {
            const response = await fetch(`${backendUrl}/cartHandler`, {
                method: "POST",
                headers: {
                    "content-type": "application/json"
                },
                body: JSON.stringify({ "email": myContext.user.email, "itemID": itemID, quantity })
            });
            if (response.ok) {
                myContext.updateCart(itemID)
            }
            else {
                console.log("info not send successfully")
            }
        }
        } catch (error) {
            console.log("Some error occured", error);
        }
       
    }

    useEffect(() => {
        getProductData();
    }, [])
    useEffect(() => {
        setSelectedImg(product ? product.images[0].preview : 'selectedImg')
    }, [product]);

    useEffect(() => {
        const handleScroll = () => {
            if (window.innerWidth <= 991) return;
            if (!sentinelUpRef.current) return;
            if (!sentinelDownRef.current) return;
            if (!galleryRef.current) return;
            const div = document.getElementById('desktop-gallery')
            const rect = div.getBoundingClientRect();
            const rect1 = detailsRef.current.getBoundingClientRect();
            const dynamicMarginTop = (rect1.height - rect.height)

            if (window.scrollY < 30) {
                galleryRef.current.classList.remove('make-fixed');
                return
            }
            if (window.scrollY + 120 > sentinelUpRef.current.getBoundingClientRect().top && window.scrollY - 12 <= dynamicMarginTop) {
                galleryRef.current.classList.add('make-fixed');
                detailsRef.current.classList.add('pull-right');
                galleryRef.current.style.marginTop = '0px';
            } else if (window.scrollY > sentinelUpRef.current.getBoundingClientRect().top && window.scrollY - 12 > dynamicMarginTop) {
                galleryRef.current.classList.remove('make-fixed');
                galleryRef.current.style.marginTop = `${dynamicMarginTop - 10}px`;
                console.log(1)
            }



        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setDelta(0.9551 * (window.innerWidth - 1380) + 200);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            {product && <div className="product-page">
                <div className="row" ref={rowRef}>
                    <div ref={sentinelUpRef} style={{ maxHeight: '.1px', width: '100%', position: 'fixed' }}></div>

                    {/* Image Gallery */}
                    <div className="col-md-6 col-xs-12 gallery-ref" style={{ maxWidth: `${((window.innerWidth) / 2) - 10}px` }} ref={galleryRef} >
                        <div className='row desktop-gallery' id='desktop-gallery'>
                            <div className='col-md-3'>
                                <div className="thumbnail-row d-flex justify-content-center">
                                    {product.images.map((image, index) => (
                                        <img
                                            key={index}
                                            src={`${adminUrl}/uploads/products/${image.preview}`}
                                            alt={`Thumbnail ${index + 1}`}
                                            className={`thumbnail-img ${selectedImg === image.preview ? 'active' : ''}`}
                                            onClick={() => setSelectedImg(image.preview)}

                                        />
                                    ))}
                                </div>
                            </div>
                            <div className='col-md-9'>
                                <div className="main-image">
                                    <img src={`${adminUrl}/uploads/products/${selectedImg}`} alt="Selected Product" className="img-fluid rounded" />
                                </div>
                            </div>

                        </div>
                        <div className='mobile-gallery'>
                            <ProductImageCarousel images={product.images} />
                        </div>

                    </div>

                    {/* Product Details */}
                    <div className="col-md-6 col-xs-12 product-details" style={{ paddingInlineEnd: "0rem" }} ref={detailsRef}>
                        <div className='starts single-feature-txt '>
                            <p>

                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <i className="fa fa-star"></i>
                                <span className="spacial-feature-icon"><i className="fa fa-star"></i></span>
                            </p>
                        </div>
                        <h2 className="product-title">{product.title}</h2>
                        {/* <p className="product-subtitle">Soft muslin nappies perfect for your baby's delicate skin.</p> */}
                        <div className="price-box">
                            <span className="current-price">₹ {product.pricing.offerPrice}</span>
                            {/* <span className="original-price">Rs. 999</span> */}
                        </div>

                        <div className="product-description mt-4">
                            <p>
                                {product.description.generalInfo}
                            </p>
                        </div>

                        <div className='product-specility'>
                            <p className=''>
                                <i className="fa-solid fa-check"></i>
                                100% breathable fabric – soft, lightweight, and gentle on delicate skin
                            </p>
                            <p className=''>
                                <i className="fa-solid fa-check"></i>
                                Absorbent toweling layer to keep baby comfortable for longer periods
                            </p>
                            <p className=''>
                                <i className="fa-solid fa-check"></i>
                                This design is very lightweight and portable and hence can be used for travel or at home.
                            </p>
                        </div>

                        <div className="quantity-box">
                            <div className="quantity-control">
                                <button onClick={() => handleQuantityChange(-1)}>-</button>
                                <span>{quantity}</span>
                                <button onClick={() => handleQuantityChange(1)}>+</button>
                            </div>
                            <div style={{ flex: '1' }}>
                                <button className="add-to-cart" onClick={(e) => { addToCartHandler(product._id) }}>Add to Cart</button>
                            </div>
                        </div>

                        <div className='offer-section'>
                            <OffersCarousel />
                        </div>
                        <div className='simple-accordian' style={{ padding: '1rem' }}>
                            <SimpleAccordion items={accordionData} />
                        </div>
                        <div style={{ position: 'relative' }}>
                            <div ref={sentinelDownRef} style={{ maxHeight: '.1px', width: '100%' }}></div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default ProductPage;
